export const SPANISH_TRANSLATIONS = {
  text: {
    book_a_reservation: 'Hacer Una Reservación',
    date_of_visit: 'Fecha de Visita',
    required: 'Requerido',
    daily_max: 'Exede límite diario',
    min_date: 'Reservaciónes mismo dia o futuro',
    max_date: 'Fecha muy lejana',
    blackout_date: 'Fecha no es disponible',
    disabled_date: 'Seleccione una fecha diferente',
    location: 'Lugar',
    locations: 'Lugares',
    select_location: 'Seleccionar un Lugar',
    location_not_allowed: 'Lugar no permitida',
    too_far_from_location: 'Lugar muy lejana',
    entrance: 'Entrada',
    select_entrance: 'Selecciona la Entrada',
    entrance_not_allowed: 'Entrada no permitida',
    select_location_first: 'Escoge Lugar Primero',
    timeslot: 'Hora de reservación',
    select_timeslot: 'Escoge Hora de Reservación',
    timeslot_not_allowed: 'Hora de reservación no es permitida',
    group_size: 'Tamańo del Groupo',
    select_group_size: 'Escoge el Tamańo del Grupo',
    group_size_not_allowed: 'No se permite el tamaño del grupo',
    name: 'Nombre',
    name_length: 'Tiene que ser 2 a 64 caracteres',
    email: 'Correo electrónico',
    email_valid: 'Entra un correo electrónico válido',
    phone: 'Teléfono',
    phone_number: 'Número de teléfono',
    phone_number_valid: 'Entra un número de teléfono valido',
    notes_valid: 'Tiene que ser 1 a 2048 caracteres',
    agree: 'Yo soy de acuerdo',
    agree_full: 'Yo exepto el completo',
    and: 'y',
    terms_and_conditions: 'términos y condiciones',
    book_reservation: 'Completar reservación',
    continue: 'Continuar',
    back: 'Regresar',
    manage_reservations: 'Administrar Reservación',
    upcoming_reservations: 'Proxima Reservación',
    reservation_details: 'Detalles de la Reservación',
    access: 'Acceso',
    thank_you: 'Gracias por tu reservación',
    qr_sent: 'Un enlace para un codigo QR asido enviado a tu',
    present_qr: 'Por favor presenta tu codigo QR quando llegas.',
    important_notes: 'Notas Importantes',
    arrive_by: 'Por favor llegan en la lugar por',
    use_the: 'Por favor usan el',
    leave_location_by: 'Tienes que ir de la lugar por ',
    new_reservation: 'Nueva Reservación',
    new_check_in: 'Nuevo Registro',
    you_are_checked_in: 'Estas registrado en',
    check_out: 'Revisa de la Lugar',
    reservation: 'Reservación',
    modify_reservation: 'Modificar Reservación',
    cancel_reservation: 'Cancelar Reservación',
    time: 'Tiempo',
    time_remaining: 'Tiempo Restante',
    expiration_date: 'Fecha de Caducidad',
    number_of_people: '# de Personase',
    at_the_location: 'en el lugar',
    view_reservation: 'Ver Reservación',
    notes: 'Notas',
    select_date_first: 'Seleccione la Fecha Primero',
    are_you_sure: 'Estas seguro',
    are_you_sure_cancel: 'Estás seguro de queries cancelar tu reservación?',
    close: 'Cerca',
    reservation_error: 'Encontramos un error',
    reservation_create_error_message:
      'Lo sientio, encontramos un error al intentar hacer su reservatión. Haga clic en el botón de abajo para volver a intentarlo.',
    reservation_cancel_error_message:
      'Lo sentimos, encontramos un error al intentar cancelar su reservación. Haga clic en el botón de abajo para volver a intentarlo.',
    try_again: 'Inténtalo de Nuevo',
    long_term_reservations: 'Reservación a Largo Plazo',
    main: 'Principal',
    add_to_calendar: 'AÑADIR AL CALENDARIO',
    reservation_at: 'Reservación en',
    all_day: 'Todo el Dia',
    enter_phone_number: 'Ingresa un número de teléfono',
    not_allowed: 'No Autorizada',
    not_allowed_message: 'No está autorizado a utilizar este enlace.',
    please_click_continue: 'Haga clic en el botón de abajo para ser redirigido y hacer una reserva pública.',
    please_contact_location: 'Comuníquese con la ubicación con la que está tratando de reservar si cree que este mensaje es un error.',
    security_code: 'Código de Seguridad',
    scanning: 'Exploración',
    sign_in: 'Registrarse',
    check_in: 'Registrarse',
    guest: 'La Visita',
    guests_in_location: 'Huéspedes en la ubicación',
    of: 'de',
    invalid_qr_code: 'Código QR no válido',
    disabled_reservation: 'La reserva está deshabilitada',
    location_at_capacity: 'Ubicación a capacidad',
    expired_manual_group: 'La reserva caducó',
    disabled_customer: 'Todas las entradas deshabilitadas',
    disabled_location: 'Todas las entradas deshabilitadas',
    disabled_occupant_type: 'Tipo de ocupante Entrada discapacitada',
    disabled_manual_group: 'Entrada de grupo deshabilitada',
    disabled_entrance: 'Entrada para discapacitados',
    disabled_timeslot: 'Intervalo de tiempo desactivado',
    entry_not_allowed_at_entrance: 'Entrada no permitida en la entrada',
    exit_not_allowed_at_entrance: 'Salida no permitida en la entrada',
    wrong_location: 'Lugar incorrecto',
    wrong_entrance: 'Entrada incorrecta',
    wrong_time: 'Tiempo Inadecuado',
    reentry_not_allowed: 'Reingreso no permitido',
    already_entered: 'Ya ingresaste',
    already_exited: 'Ya salida',
    date: 'La Fecha',
    manual_group_name: 'Nombre del Grupo',
    entry_approved: 'Entrada aprobada',
    exit_approved: 'Salida aprobada',
    invalid_code: 'Codigo Invalido',
    sign_out: 'Desconectar',
    are_you_sure_sign_out: '¿Estás segura de que quieres cerrar sesión?',
  },
  html: {
    temperature_taken: '<strong>tomar mi temperatura</strong>',
    masks_required: 'uso <strong>cubrebocas personal</strong>',
  },
};
